import { storeProvider, getRegisteredApis } from 'ReduxHelpers';
import { reset as resetMessagingSlice } from 'Messaging';
import { chatActions } from 'TutorBotChat';
import { voiceAgentActions } from 'TutorBotVoiceAgent';
import { setGhostMode } from 'Users/ghostModeSlice';

/**
 * Resets all user-specific state in the Redux store.
 *
 * This should be called when switching users (e.g., "Log In As" feature)
 * to ensure the new user doesn't see cached data from the previous user.
 *
 * Resets:
 * - All RTK Query API caches (via resetApiState)
 * - User-specific Redux slices (messaging, chat, voice agent)
 */
export function resetAllUserSpecificState(): void {
    // Reset all RTK Query API caches
    // This clears cached responses from all registered APIs (e.g., gradingPortalApi, careerProfilesApi, etc.)
    const apis = getRegisteredApis();
    apis.forEach(api => {
        // RTK Query APIs have a util.resetApiState method that clears the cache
        // We use type assertion here because LooksLikeAnApi is a generic type
        // that doesn't include the util property definition
        const util = (api as { util?: { resetApiState?: () => { type: string } } }).util;
        if (util?.resetApiState) {
            storeProvider.dispatch(util.resetApiState());
        }
    });

    // Reset user-specific Redux slices
    storeProvider.dispatch(resetMessagingSlice());
    storeProvider.dispatch(chatActions.reset());
    storeProvider.dispatch(voiceAgentActions.reset());
    storeProvider.dispatch(setGhostMode(false));
}
